import { gql, useQuery } from '@apollo/client';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../swiper/Header';
import Summary from '../swiper/Summary';

const GET_APPLICATION = gql`
  query pub_OpenApplication($applicationId: String!) {
    OpenApplication(applicationId: $applicationId) {
      id
      score
      status
      score
      stage
      createdAt
      accepted
      activityLog {
        createdAt
        status
        stage
        actionType
        message
      }
      candidate {
        id
        firstName
        lastName
        email
        phoneNumber
      }
      job {
        id
        company
        title
        threshold
        location {
          name
        }
        position
      }
      _summaries {
        id
        threshold
        aiDetection {
          isAi
          score
          tag
        }
        summaryPart: summary {
          header
          icon
          bonuspoints
          average
          points
          maxPoints
          threshold
          details {
            label
            question
            icon
            answer
            points
            bonuspoints
            isCorrect
            qualified
            media {
              kind
              link
              durationSeconds
              thumbnailLink
            }
            options {
              label
              points
              isCorrect
              answered
              evaluation {
                name
                value
                bonus_points
              }
            }
            aiDetection {
              isAi
              score
              tag
            }
            reset
          }
        }
      }
    }
  }
`;

const OpenApplication = ({ applicationId, whileLoading }: { applicationId: string; whileLoading?: ReactNode }) => {
  const { t } = useTranslation();
  const { loading, error, data } = useQuery(GET_APPLICATION, { variables: { applicationId: applicationId } });
  if (loading) return whileLoading ?? t('openApplication.loading');
  if (error) return t('openApplication.error', { errorMessage: error.message });

  const job = data.OpenApplication.job;

  return (
    <div className="main-container mx-auto">
      <span className="my-auto header-row flex justify-between mx-0 p-2">
        <span className=" float-left">
          <h3>
            {job.company} - {job.title}
          </h3>
          <h4>
            {job && job.position && <span>{job.position} - </span>}
            {job && job.location && job.location.name && <span>{job.location.name}</span>}
          </h4>
        </span>
      </span>
      <Header
        application={data.OpenApplication}
        onStatusChange={() => {}}
        editableStatus={false}
        reInvite={false}
        candidateDropdown={false}
      />
      <Summary className="swiper-actionbar-offset" summaries={data.OpenApplication._summaries} />
    </div>
  );
};

export default OpenApplication;
